/// <amd-module name="Repos/Views/MyPullRequestsOrgHomeTab/MyPullRequestsOrgHomeTab" />
import * as React from "react";
import { PullRequestsList } from "Repos/PullRequestList/Components/PullRequestsList";
import { IPullRequestDataProviderService } from "Repos/PullRequestList/PullRequestDataProviderService";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class MyPullRequestsOrgHomeTab extends VssComponent<{}> {
    private reload = false;

    public render() {
        const prListService = this.context.pageContext.getService<IPullRequestDataProviderService>("IPullRequestDataProviderService");
        const sections = prListService.getPullRequestSections(this.reload);
        this.reload = false;

        return (
            <div className="page-content page-content-top flex-column flex-grow rhythm-vertical-16">
                <PullRequestsList
                    onLoaded={() => {
                        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
                        performanceService.markTimeToInteractive("Repos", "my-prs-org-home-tab");
                    }}
                    onToggleDecline={pr => prListService.toggleDeclineToReview(pr)}
                    onToggleFlagged={pr => prListService.toggleFlagged(pr)}
                    sections={sections}
                    showRepository={true}
                />
            </div>
        );
    }
}

Components.add("vss-code-web-my-prs-org-home-tab", MyPullRequestsOrgHomeTab);
